module.exports = __webpack_public_path__ + "assets/img/report-title.c69f9397.png";